<div class="vc-modal__innerContainer vc-modal__innerContainer--full authentication__container" aria-modal="true">
  <p id="acc-dialogHeading" class="visuallyhidden" i18n="@@LOGIN_MODAL.TITLE">Log in</p>
  <button (click)="continueAsGuest()" class="vc-dialog__closeBtn vc-d-none vc-d-md-block" [mat-dialog-close]>
    <span i18n="@@MODAL.BUTTON.CLOSE" class="vc-dialog__closeBtn__text">Close</span>
    <vc-sprite-icons name="cross-x-thick" class="vc-dialog__closeBtn__icon"></vc-sprite-icons>
  </button>
  <div class="authentication__gridContainer">
    <div class="vc-d-none vc-d-md-flex">
      <div aria-hidden="true" class="authentication__actionVisual"></div>
    </div>
    <div class="authentication__gridContainer__vertical">
      <div
        class="authentication__actionContainer"
        [ngClass]="{
          'authentication__actionContainer--register': popover,
          'authentication__actionContainer--mobileScreen': type === 'login-register'
        }"
      >
        <ng-container *ngIf="type === 'register'">
          <div class="authentication__registerContainer" *ngIf="!resetPassword">
            <vc-register
              [popinForced]="popinForced"
              [promoOffer]="promoOffer"
              [credentialFirstname]="firstname"
              (registerFirstStep)="registerFirstStep = $event"
            ></vc-register>
            <button class="vc-dialog__closeBtn vc-d-md-flex vc-d-lg-none" [mat-dialog-close]>
              <span i18n="@@MODAL.BUTTON.CLOSE" class="vc-dialog__closeBtn__text">Close</span>
              <vc-sprite-icons class="vc-dialog__closeBtn__icon" name="cross-x-thick"></vc-sprite-icons>
            </button>
          </div>
          <ng-container *ngIf="registerFirstStep">
            <div class="authentication__toggleLoginSubscribe vc-text-m" i18n="@@AUTH.SWITCH.LOGIN.ACCOUNT">
              Already have an account ?
              <button
                class="authentication__toggleLoginSubscribe__btn"
                aria-haspopup="dialog"
                (click)="displayComponent('login')"
              >
                Log in
              </button>
            </div>
            <button
              (click)="continueAsGuest()"
              class="authentication__guestDesktop vc-d-none vc-d-md-block vc-text-m"
              i18n="@@MODAL.BUTTON.GUEST"
              [mat-dialog-close]
            >
              Continue as guest
            </button>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="type === 'login'">
          <div *ngIf="!resetPassword">
            <div class="authentication__loginContainer">
              <vc-login
                (displayResetPassword)="displayResetPassword($event)"
                (currentEmail)="setCurrentEmail($event)"
                [popinForced]="popinForced"
              ></vc-login>
              <button class="vc-dialog__closeBtn vc-d-md-flex vc-d-lg-none" [mat-dialog-close]>
                <span i18n="@@MODAL.BUTTON.CLOSE" class="vc-dialog__closeBtn__text">Close</span>
                <vc-sprite-icons class="vc-dialog__closeBtn__icon" name="cross-x-thick"></vc-sprite-icons>
              </button>
            </div>
            <div class="authentication__toggleLoginSubscribe vc-text-m" i18n="@@AUTH.SWITCH.REGISTER">
              Not a member yet ?
              <button
                class="authentication__toggleLoginSubscribe__btn"
                aria-haspopup="dialog"
                (click)="displayComponent('register')"
              >
                Register
              </button>
            </div>
          </div>
          <div *ngIf="resetPassword" class="authentication__passwordResetContainer">
            <vc-password-reset
              [currentEmail]="email"
              [popinForced]="popinForced"
              (displayResetPassword)="displayResetPassword($event)"
              class="authentication__passwordReset"
            >
            </vc-password-reset>
          </div>
        </ng-container>
        <ng-container *ngIf="type === 'login-register'">
          <div class="authentication__loginContainer authentication__loginContainer--mobileScreen">
            <vc-login-register-screen
              (switchModal)="displayComponent($event)"
              [popinForced]="popinForced"
              [promoOffer]="promoOffer"
              (onClosePopin)="continueAsGuest()"
            >
            </vc-login-register-screen>
          </div>
        </ng-container>
        <div class="authentication__actionContainer__recommendedBy">
          <div class="recommendedBy__txt" i18n="@@LOGIN_MODAL.RECOMMENDED_BY">Recommended by</div>
          <img class="vc-icon" src="/assets/svg/logo-vogue.svg" alt="" />
          <img class="vc-icon" src="/assets/svg/logo-glamour.svg" alt="" />
          <img class="vc-icon" src="/assets/svg/logo-gq.svg" alt="" />
          <img class="vc-icon" src="/assets/svg/logo-vanityfair.svg" alt="" />
          <img class="vc-icon" src="/assets/svg/logo-ad.svg" alt="" />
        </div>
        <div class="authentication__actionContainer__rgpd" *ngIf="type === 'register'">
          <div
            class="authentication__actionContainer__rgpd__popover"
            *ngIf="popover"
            i18n="@@LOGIN_MODAL.RGPD.RGPD_TEXT"
          >
            We hereby inform you that the personal data you provide in this form is collected and processed by Vestiaire
            Collective for the purpose of managing your user accounts, your complaints (if any), the services you
            subscribe and the products you purchase or sell, for sending you our newsletters and advertisements and for
            carrying out surveys and statistics. In accordance with applicable regulations, you have the right to
            access, block, modify and delete your personal data and the right to give instructions concerning the use of
            your personal data after your lifetime. You also have a right to data portability and a right to restrict
            the processing of your data in certain specific cases stipulated in EU Regulation No 2016/679 of 27 April
            2016. To exercise your rights, please contact dataprivacy@vestiairecollective.com
          </div>
          <button class="authentication__actionContainer__rgpd__link" (click)="togglePopover()">
            <ng-container *ngIf="!popover" i18n="@@LOGIN_MODAL.RGPD.RGPD_LINK_SHOW_TEXT"
              >Learn more about my data</ng-container
            >
            <ng-container *ngIf="popover" i18n="@@LOGIN_MODAL.RGPD.RGPD_LINK_HIDE_TEXT">Close</ng-container>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
